import commonPostTypeConfig from '../../common/postTypes/page'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'page',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
